import React from 'react';

import ReactDOM from 'react-dom';

import './configs';
import './helpers/i18n-next';
import App from './app';
import makeServer from './server';

if (process.env.REACT_APP_MOCK_SERVER === 'true') {
  makeServer();
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
